export const LEGAL_PATHS = { terms: "/terms", privacy: "/privacy" };

export async function openLegalWebPage(path) {
  if (typeof window !== "undefined" && path) {
    window.open(path, "_blank", "noopener,noreferrer");
  }
}

export async function openDeletionStatusPage() {}
